import {
  Center,
  experimental_I18nProvider as I18nProvider,
  Spinner,
  csx,
} from '@vtex/admin-ui'
import { useAdmin } from '@vtex/raccoon-next'
import { useLogger, useMessages } from 'hooks'
import { DEFAULT_LOCALE } from 'messages'
import { useEffect, useRef } from 'react'
import { IntlProvider, MissingTranslationError } from 'react-intl'
import { IntlErrorLogger } from './intlErrorLogger'

export enum MESSAGES_TYPE {
  Promotions = 'promotions',
}

type Props = {
  children: React.ReactNode
  messageTypes: MESSAGES_TYPE[]
  supportedLanguages?: string[]
}

export function AdminIntlProvider(props: Props) {
  const { messageTypes, children, supportedLanguages } = props
  let { locale = DEFAULT_LOCALE } = useAdmin()

  const { logger } = useLogger()
  const intlLoggerRef = useRef<IntlErrorLogger | null>(null)

  const [language] = locale.split('-')

  if (
    supportedLanguages !== undefined &&
    !supportedLanguages.includes(language)
  ) {
    locale = DEFAULT_LOCALE
  }

  const { data: messages, isLoading: loadingMessages } = useMessages(
    locale,
    messageTypes
  )

  useEffect(() => {
    if (logger && !intlLoggerRef.current) {
      intlLoggerRef.current = new IntlErrorLogger(logger)
    }
  }, [logger])

  if (loadingMessages) {
    return (
      <Center className={csx({ position: 'fixed', size: 'full' })}>
        <Spinner />
      </Center>
    )
  }

  const handleError = (error: MissingTranslationError) => {
    if (intlLoggerRef.current) {
      intlLoggerRef.current.logError(error, language)
    }
  }

  return (
    <IntlProvider messages={messages} locale={locale} onError={handleError}>
      <I18nProvider locale={locale}>{children}</I18nProvider>
    </IntlProvider>
  )
}
